import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import searchIcon from './../../../../../../Assets/icons/searchicon.svg';
import downloadIcon from './../../../../../../Assets/icons/download.svg';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg';
import prividegeIcon from './../../../../../../Assets/icons/priviledgeIcon.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API'; 
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import { IoMdClose } from 'react-icons/io';
import Loader from '../../../../../customComponents/CustomLoader';

const RoleList = () => {
  const [roleData, setRoleData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const token = localStorage.getItem("authToken");



  const fetchRoleData = async (page = 0, pageSize = 10) => {
    
    try {
      setLoading(true)
      const response = await axiosInstance.post('/role/list', {
        orderBy: 'role_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setRoleData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching role list:', error);
    }
    finally{ 
        setLoading(false)
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchRoleData(newPage);
  };

  const handleSearchInputChange = (event) => {
    const searchvalue= event.target.value
    setSearchTerm(event.target.value);
    console.log("searchvalue",searchvalue);
    
    if(searchvalue===''){
      fetchRoleData()
    }  
  };
  const clearSearchAndFetch = () => {
    setSearchTerm(''); 
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchRoleData({ searchText: '' });
    }
  }, [searchTerm]);

  const handleKeyPress = (e) => {
    console.log("keyname",e.key);
    
    if (e.key === 'Enter') {
      fetchRoleData(0, 10, searchTerm); 
    }
  }
  

  const USERROLE_TABLE_HEADERS = [
    "Role Name",
    "Description",
    "Status",
    "Action"
  ];

  const USERROLE_KEY_MAPPING = {

    "Role ID": "role_id",
    "Role Name": "role_name",
    "Description": "role_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "priviledge", icon: prividegeIcon, label: "priviledge" },
    ]
  };


  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITROLE}`, { state: { data: rowData } });
  }

  const handlePriviledges = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.USERPRIVILEDGES}`, { state: { data: rowData } });
   console.log("rowdata", rowData)
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Role Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div className='topleftdataContainer' style={{borderRight: "1px solid black"}} >
            <h5 className="listTopDataValueText"  >{totalData} </h5>
            <h6>All Roles</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid black"}} >
            <h5 className="listTopDataValueText"  >{totalActive} </h5>
            <h6>Active Roles</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText"  >{totalInactive} </h5>
            <h6>Inactive Roles</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-role/role/add-role')}>
              Add Role
            </button>
          </div>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Roles List</h5>
            <div className="searchinput-wrapper">
              <input
                type='text'
                className='searchinput'
                placeholder='Search Role'
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={handleKeyPress}
              />
                {searchTerm ? (
              <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch}
                />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
              </div>
          </div>
        
        </div>

        <CustomTable 
        data={roleData} headers={USERROLE_TABLE_HEADERS} keyMapping={USERROLE_KEY_MAPPING}  itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          onPriviledges={handlePriviledges} 
          totalRecords={totalRecords}
          isasignLead={false}
          />
      </div>
      </div>
      )}
  </div>
  );
};

export default RoleList;
